module.exports = __webpack_public_path__ + "static/media/foundation_popupImg2.8fddd9ee.png";